import React, { useEffect, useState } from "react";
import "./Services.css";
import { useConfigs } from "./components/ConfigsContext";
import ImageSlide from "./components/ImageSlider";

const Services = () => {
  const { loading, error, data } = useConfigs();
  const [serviceData, setServiceData] = useState([]);

  useEffect(() => {
    if (data) {
      const servicesData = data.services.data;
      const serviceSliders = {
        slider_one: [],
        slider_two: [],
        slider_three: [],
      };

      servicesData.map((service) => {
        const slider = {
          image: service.attributes.service_image.data.attributes.url,
          name: service.attributes.service_name,
          color: service.attributes.slider_bg_color,
          order: service.attributes.slider_display_order
        };
        serviceSliders[service.attributes.slider_type].push(slider);
        return null;
      });

      Object.keys(serviceSliders).forEach((sliderType) => {
        serviceSliders[sliderType].sort((a, b) => {
          return a.order - b.order;
        });
      });

      const hasSliders = Object.values(serviceSliders).every(
        (slides) => slides.length > 0
      );
      if (hasSliders) {
        setServiceData(serviceSliders);
      }
    }
  }, [data]);
  return (
    <div className="services-container" id="services">
      <h1>Services</h1>
      {loading ? (
        <div>Loading...</div>
      ) : error ? (
        <div>Error: {error.message}</div>
      ) : (
        serviceData.length !== 0 && (
          <div className="services-row">
            <div className="services-carousel">
              <ImageSlide slides={serviceData.slider_one} />
            </div>
            <div className="services-carousel">
              <ImageSlide slides={serviceData.slider_two} />
            </div>
            <div className="services-carousel">
              <ImageSlide slides={serviceData.slider_three} />
            </div>
          </div>
        )
      )}
    </div>
  );
};

export default Services;
